import actionTypes from '../constants/action-types';

const removePageBinding = (pageId, bindingId) => ({
  type: actionTypes.REMOVE_BINDING,
  payload: { pageId, bindingId },
});

export default removePageBinding;
